// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"CustomTable_custom_table__2hkns","nodata":"CustomTable_nodata__3hp4e"};